import React, { Component } from 'react'

import moment from 'moment'
import FlatButton from 'material-ui/FlatButton'
import DatePicker from 'material-ui/DatePicker'

export default class DateItem extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      date: moment(props.dateStr)
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ date: moment(nextProps.dateStr) })
  }

  render() {
    return (
      <div
        style={{ width: '110px' }}>
        <FlatButton
          style={{ width: this.props.width, height: 32 }}
          label={this.state.date.format(this.props.dateFormat)}
          labelStyle={{ color: '#616161', fontSize: 14, textTransform: 'none', padding: 0 }}
          onTouchTap={() => {
            this.refs.datePicker.openDialog()
          }}
          disabled={this.props.disabled}/>

        <DatePicker
          ref='datePicker'
          style={{ display: 'none' }}
          textFieldStyle={{ fontSize: 14 }}
          autoOk={true}
          firstDayOfWeek={0}
          locale="en-US"
          value={this.state.date.toDate()}
          hintText="date"
          onChange={(n, date) => this.props.onDateChange(date)}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/date/DateItem.js